var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"background",rawName:"v-background",value:(_vm.src),expression:"src"}],staticClass:"THUMBNAIL x-pulse"})
}
var staticRenderFns = []

export { render, staticRenderFns }